export default {
  data () {
    return {
      addressFormData: {
        loading: false,
        isAccepted: false,
        address: {
          building: '',
          floor: '',
          streetType: '',
          street: '',
          houseNumber: null,
          annex: '',
          postalCode: '',
          city: '',
          region: ''
        }
      }
    }
  },
  computed: {
    addressFormDataProps () {
      const { loading, address } = this.addressFormData

      return {
        loading,
        address
      }
    },
    addressModalDataProps () {
      const { address, isAccepted } = this.addressFormData

      return {
        address,
        isAccepted
      }
    }
  },
  methods: {
    checkFormAddress ({ address, country, callback = () => {} }) {
      this.addressFormData.loading = true

      // Insert future address checks here

      const result = {
        country,
        address,
        isAccepted: true
      }

      delete address.country

      this.addressFormData.address = { ...address, ...result.address }
      this.addressFormData.isAccepted = result.isAccepted

      callback()

      this.addressFormData.loading = false
    }
  }
}
